<template>
    <div class="tableComponent">
        <!--:max-height="tableMaxheight"-->
        <el-table lazy
                  ref="eltable" :data="tableData" :max-height="tableMaxheight+'px'" scrollbar-always-on="true"
                  @selection-change="handleSelectionChange"
                  @row-dblclick="rowDblclick"
                  style="width: 100%">
            <el-table-column fixed align="center" header-align="center" type="selection" width="55"/>
            <!--<el-table-column-->
            <!--prop="date"-->
            <!--label="Date"-->
            <!--:sortable="true"-->
            <!--width="180"-->
            <!--column-key="date"-->
            <!--filters="null"-->
            <!--:filter-method="filterHandler"-->
            <!--/>-->
            <!--<el-table-column prop="name" label="Name" :sortable="false" width="180"/>-->
            <!--<el-table-column prop="address" label="Address" :formatter="formatter"/>-->
            <el-table-column
                v-for="item in tableHeaderArray"
                :prop="item.field"
                :label="item.name"
                show-overflow-tooltip="true"
                :sortable="item.sfpx==1?true:false"
                :filters="item.sfsx==1?item.sxable:null"
                :filter-method="item.sfsx==1?filterHandler:null"
                filter-placement="bottom-end"
            >
                <template #default="scope">
                    <div v-if="tableTemplateShow(item.field)" v-html="tableTemplateHtml(scope.row,item.field)"></div>
                    <span v-else :style="{color:scope.row[item.prop+'_color']}">{{scope.row[item.field]}}</span>
                    <!--{{ scope.row[item.prop] }}-->
                    <!--<div v-html="scope.row[item.prop]">-->
                    <!--</div>-->
                </template>
            </el-table-column>
            <el-table-column fixed="right" align="center" header-align="center" style="width:90px">
                <template
                    slot="header"
                    #header="scope"
                >
                    <div class="opreate">
                        <span>操作</span>
                        <el-dropdown>
                            <el-icon>
                                <setting/>
                            </el-icon>
                            <template #dropdown>
                                <div class="selectTableTitle">
                                    <div class="selectTableTitle_checkbox">
                                        <el-checkbox-group v-model="selectedTableHeader">
                                            <el-checkbox v-for="item in tableHeadAll" :label="item.field" size="large">
                                                {{item.name}}
                                            </el-checkbox>
                                        </el-checkbox-group>
                                    </div>
                                    <div class="selectTableTitle_btn">
                                        <div class="selectTableTitle_btn_cancle">
                                            取消
                                        </div>
                                        <div class="selectTableTitle_btn_sure" @click="selectedTableHeaderSure">
                                            确认
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </el-dropdown>
                    </div>
                </template>
                <template #default="scope">
                    <el-button
                        type="text"
                        size="small"
                        @click.prevent="viewDetails(scope.row)"
                    >
                        查看
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    import {reactive, ref, watch, onMounted, getCurrentInstance} from 'vue'
    import {useStore} from 'vuex'

    export default {
        name: "TableComponent",
        props: ['tableArray'],
        setup(props, context) {
            const {proxy} = getCurrentInstance();
            const store = useStore();
            //表格数据
            let tableData = ref();
            let eltable = ref();
            tableData.value = props.tableArray;
            watch(() => props.tableArray, (newVal) => {
                tableData.value = newVal
            });
            let tableMaxheight = ref(0)
            //计算表格最大高度
            const tableMaxheightFun = () => {
                setTimeout(() => {
                    const clientHeight = document.documentElement.clientHeight;
                    const clientWidth = document.documentElement.clientWidth
                    tableMaxheight.value = clientHeight - (48 + 24 +  48+72+68) * clientWidth / 1920;
                    // tableMaxheight.value = clientHeight - (48 + 24 + store.state.wgsjSearchHight + 48) * clientWidth / 1920;
                }, 0)
            }
            watch(()=>store.state.wgsjSearchHight,(newVal)=>{
                tableMaxheightFun();
            })
            //查询表格头部所有字段
            let tableHeadAll = ref();
            const queryTableHeadAll = () => {
                proxy.$axios.post("/jgfast/wgsj/selGdtzzd").then((res) => {
                    tableHeadAll.value = res.data
                })
            }
            //查询用户保存的表格头部字段
            let tableHeaderArray = ref([]);
            const queryUserSaveTableHead = () => {
                proxy.$axios.post("/jgfast/wgsj/selYhdyGdtzzd").then((res) => {
                    tableHeaderArray.value = res.data;
                    selectedTableHeader.value = [];
                    for (let i in res.data) {
                        selectedTableHeader.value.push(res.data[i].field)
                    }
                })
            }
            const filterHandler = (value, row, column) => {
                const property = column['property']
                if(row[property]){
                    return row[property].indexOf(value) > -1
                }else{
                    return false
                }

            }
            const handleSelectionChange = (param) => {
                context.emit("checkGdEva", param)
            }
            //操作选择table头部
            let selectedTableHeader = ref([]);
            const selectedTableHeaderSure = () => {
                proxy.$axios.post("/jgfast/wgsj/saveYhdyGdtzzd", {"field": selectedTableHeader.value.join(",")}).then((res) => {
                    queryUserSaveTableHead();
                })
            }
            //查看点击事件
            const viewDetails = (param) => {
                store.commit('addLeftTreeToHeaderTab', {
                    name: "Hotline",
                    label: param.gdGdbh,
                    linkTo: "/Hotline",
                    query: {
                        gdId: param.gdId
                    },
                });
            }
            const rowDblclick = (row) => {
                viewDetails(row)
            }
            const tableTemplateHtml = (param, name) => {
                var html = '';
                //超时指示灯
                if (name == 'otSign') {
                    if (param[name] == 1) {
                        html += "<div class='table_cszsd_true'></div>"
                    } else if (param[name] == 2) {
                        html += "<div class='table_cszsd_yellow'></div>"
                    } else {
                        html += "<div class='table_cszsd_false'></div>"
                    }
                }
                return html
            }
            const tableTemplateShow = (param) => {
                if (param == 'otSign') {//核查状态
                    return true
                } else {
                    return false
                }
            }
            //清除table排序条件
            const clearSortTable = () =>{
                eltable.value.clearFilter();
                eltable.value.clearSort();
                eltable.value.clearSelection();
            }
            onMounted(() => {
                queryTableHeadAll();
                queryUserSaveTableHead();
                tableMaxheightFun();
                window.addEventListener('resize', function () {
                    tableMaxheightFun();
                }, true);
            });
            return {
                tableData,
                filterHandler,
                handleSelectionChange,
                tableHeaderArray,
                selectedTableHeader,
                selectedTableHeaderSure,
                tableHeadAll,
                viewDetails,
                tableMaxheight,
                rowDblclick,
                tableTemplateHtml,
                tableTemplateShow,
                eltable,
                clearSortTable
            }
        }
    }
</script>

<style lang="less">

</style>
